import React, { useEffect, useState } from 'react';
import './App.css'

const ScoreBoardTable= () => {
  
  const [scores, setScores] = useState([]);
  const [gameSelected, setGameSelected] = useState('1');
  const [gameTitle, setGameTitle] = useState('');
  const [message, setMessage] = useState('');
  const host = window.location.hostname

  function formatOutput(score) {
    if(gameSelected === '1' || gameSelected === '3' || gameSelected === '6'){
      const minutes = Math.floor(score / 60);
      const seconds = Math.floor(score) % 60;
      const tenths = Math.floor((score - Math.floor(score)) * 10);
      const hundredths = Math.floor((score - Math.floor(score) - tenths / 10) * 100);

      return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}.${tenths}${hundredths}`;

    }else{
      return`${score}`
      
    }
  }
  
  const fetchResults = async () =>{
    try {
      const response = await fetch(`/topScores?game=${gameSelected}`);
      const data = await response.json();
      setScores(data.players)
      setGameTitle(data.gameTitle)
      console.log(data)
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };
  
 useEffect(() => {
    fetchResults();
    
    if(gameSelected === '1' || gameSelected === '3' || gameSelected === '6'){
      setMessage('Score shown as Min:Seconds');
    }else{
      setMessage('Score show as Total Points');      
    }

    // Fetch results every 2 minutes (120000 milliseconds)
    const interval = setInterval(fetchResults, 120000);

    // Clean up the interval when the component unmounts
    return () => {
    clearInterval(interval);
    };

  },[gameSelected]);
  

  return (
    <div>
       <div>
        <select  name="gameSelected" value={gameSelected} onChange={(e) => setGameSelected(e.target.value)}>
          <option value="0">--Select a Game--</option>
          <option value="1">Sonic Adventure 2 Battle</option>
          <option value="2">Pokemon Yellow - Surfing Pikachu</option>
          <option value="3">Garou: Mark of the Wolves</option>
          <option value="4">Vib Ribbon</option>
          <option value="5">Game and Watch Gallery 3 - Turtle Bridge</option>
          <option value="6">Mischief Makers</option>
          <option value="7">Final Fantasy 9 - Jump Rope</option>
          <option value="8">Just Dance</option>
          <option value="9">Space Invaders 95</option>
          <option value="10">Nintendo Land - DK Crash Course</option>
          <option value="11">Robot Unicorn Attack</option>
          <option value="12">Mega Man 10 - Endless Mode</option>
          <option value="13">Evangelion: Typing Project Advanced</option>
          <option value="14">Tetris: The Absolute The Grand Master 2</option>
        </select>
      </div>

      <div className='caption-container'><h1>{gameTitle}</h1></div>
    
    <table>
      <thead>
        <tr>
          <th>Name</th>
          <th>Score</th>
        </tr>
      </thead>
      <tbody>
        {scores.map((score,index)=>
        (
          <tr key={index}>
            <td>{score.playerName}</td>
            <td>{formatOutput(score.score)}</td>
          </tr>
        )
        )}
      </tbody>
    </table><br/><br/>
    
    <p className='large-text'>{message}</p><br/><br/>
    </div>
  );
};

export default ScoreBoardTable;
